import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loose_graphics/color/g.svg")